if (!customElements.get('product-inventory')) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      if (this.hidden) {
        this.initLazySection();
      } else {
        window.initLazyScript(this, this.initLazySection.bind(this));
      }
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector('.js-inventory-notice');
      this.urgencyMessage = this.querySelector('.js-inventory-urgency');
      this.indicatorBar = this.querySelector('.js-inventory-indicator');
      this.locationsInventory = this.querySelector('.js-locations-inventory');
      this.variantInventory = this.getVariantInventory();

      const variantPicker = this.closest('.product-info')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      const currentVariantId = this.getCurrentVariantId();
      let initialLocationsInventory = null;
      
      if (currentVariantId && this.variantInventory) {
        const currentVariantInventory = this.variantInventory.find(
          (variant) => variant.id === currentVariantId
        );
        if (currentVariantInventory && currentVariantInventory.locations_inventory) {
          initialLocationsInventory = currentVariantInventory.locations_inventory;
        }
      }
      
      if (!initialLocationsInventory) {
        const locationsInventoryData = this.dataset.locationsInventory;
        if (locationsInventoryData && locationsInventoryData !== 'null' && locationsInventoryData !== '' && locationsInventoryData !== '[]') {
          try {
            const parsed = JSON.parse(locationsInventoryData);
            if (Array.isArray(parsed) && parsed.length > 0) {
              initialLocationsInventory = parsed;
            }
          } catch (e) {
            console.warn('Failed to parse locations inventory:', e);
          }
        }
      }
      
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === 'true',
        this.dataset.inventoryPolicy,
        initialLocationsInventory
      );
    }

    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return this.variantInventory || JSON.parse(dataEl.textContent);
    }

    getCurrentVariantId() {
      const productForm = this.closest('.product-info')?.querySelector('.js-product-form-main') || 
                          this.closest('.js-product')?.querySelector('.js-product-form-main');
      if (productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
          return parseInt(variantInput.value, 10);
        }
      }
      return null;
    }

    handleVariantChange(evt) {
      if (evt.detail.variant) {
        const inventory = this.variantInventory.filter(
          (variant) => variant.id === evt.detail.variant.id
        )[0];
        this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy,
          inventory.locations_inventory
        );
      } else {
        this.updateInventory(0, false, null, null);
        this.hidden = true;
      }
    }

    updateInventory(count, available, inventoryPolicy, locationsInventory) {
      // --- DAVID OVERRIDE START ---
      const productTitle = (document.querySelector('h1')?.innerText || "").toLowerCase();
      const isForcedItem = productTitle.includes('oven') || productTitle.includes('hood') || productTitle.includes('vent');
      
      if (isForcedItem) {
        this.hidden = false;
        if (this.inventoryNotice) {
            this.inventoryNotice.innerText = '✓ In Stock';
            this.inventoryNotice.style.color = '#1a7f37';
        }
        if (this.urgencyMessage) this.urgencyMessage.innerHTML = '';
        if (this.indicatorBar) this.indicatorBar.hidden = true;
        this.setAttribute('data-inventory-level', 'normal');
        return; // Stop the rest of the script from overwriting this
      }
      // --- DAVID OVERRIDE END ---

      if (this.locationsInventory) {
        this.locationsInventory.innerHTML = '';
        if (locationsInventory && Array.isArray(locationsInventory) && locationsInventory.length > 0) {
          locationsInventory.forEach((item) => {
            this.locationsInventory.innerHTML += `<div class="product-info__locations-inventory-item">${item.location}: ${item.available} in stock</div>`;
          });
        }
      }

      if (count === 0 && !available && this.hidden) return;

      let inventoryLevel;
      if (count <= 0) {
        if (inventoryPolicy === 'continue') {
          inventoryLevel = 'backordered';
        } else if (available) {
          inventoryLevel = 'in_stock';
        } else {
          inventoryLevel = 'none';
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = 'very_low';
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = 'low';
      } else {
        inventoryLevel = 'normal';
      }

      if (((this.dataset.showNotice === 'always'
        || (this.dataset.showNotice === 'low' && inventoryLevel.includes('low')))
        && !(inventoryLevel === 'backordered' && this.dataset.showNoStockBackordered === 'false'))) {
        this.hidden = false;

        this.setAttribute('data-inventory-level', inventoryLevel);

        if (inventoryLevel === 'backordered') {
          this.inventoryNotice.innerText = '';
        } else if (inventoryLevel !== 'in_stock' && (this.dataset.showCount === 'always' || (this.dataset.showCount === 'low' && inventoryLevel.includes('low')))) {
          this.inventoryNotice.innerText = theme.strings.onlyXLeft.replace('[quantity]', count);
        } else if (inventoryLevel === 'very_low') {
          this.inventoryNotice.innerText = theme.strings.veryLowStock;
        } else if (inventoryLevel === 'low') {
          this.inventoryNotice.innerText = theme.strings.lowStock;
        } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
          this.inventoryNotice.innerText = theme.strings.inStock;
        } else if (inventoryLevel === 'none') {
          this.inventoryNotice.innerText = theme.strings.noStock;
        }

        if (this.urgencyMessage) {
          if (inventoryLevel === 'very_low') {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === 'low') {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === 'backordered') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (inventoryLevel === 'normal' || inventoryLevel === 'in_stock') {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === 'none') {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;
          let newWidth;
          if ((count >= this.dataset.scale || inventoryLevel === 'in_stock') && inventoryLevel !== 'backordered') {
            newWidth = 100;
          } else {
            newWidth = ((100 / parseInt(this.dataset.scale, 10)) * count).toFixed(1);
          }
          this.indicatorBar.querySelector('span').style.width = `${newWidth}%`;
        }
      } else {
        this.hidden = true;
      }
    }
  }

  customElements.define('product-inventory', ProductInventory);
}